import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import 'firebase/compat/firestore';
import { html } from '@polymer/polymer/polymer-element';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class';
import { serverTimestamp } from 'firebase/firestore';
import { KatapultWidget } from './katapult-widget';
import { DefaultComputedBindings } from '../../../modules/DefaultComputedBindings.js';
import '@polymer/paper-slider';
import '../../katapult-dialog-legacy/katapult-dialog-legacy';
import '../../katapult-elements/katapult-dialog.js';
import '../../katapult-elements/katapult-icon.js';
import { KatapultDialog } from '../../katapult-elements/katapult-dialog.js';
import '../../style-modules/paper-table-style';
import { DateTime, Duration } from 'luxon';
import Chart from 'chart.js/auto';
import randomColor from '../../../modules/_deprecated/RandomColor.js';
import { AdminExports } from './admin-exports/AdminExports';
import { Download } from '../../../modules/Download.js';
import '../../katapult-elements/katapult-button.js';
import { Fireworks } from '../../../modules/Fireworks.js';
import { addFlagListener, removeFlagListener } from '../../../modules/FeatureFlags.js';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';
import { ListenToUserRole } from '../../../modules/Roles.js';
import { getCompanyTeams } from '../../../modules/katapult-company/CompanyTeams.js';

class KatapultTimesheet extends mixinBehaviors([DefaultComputedBindings], KatapultWidget) {
  static get widgetTitleTemplate() {
    return html`Timesheet Payroll Week`;
  }

  static get primaryControlTemplate() {
    return html`
      <span style="display: flex; align-items: center;">
        <katapult-button
          size="small"
          color="var(--secondary-color)"
          style="margin-right: 6px;"
          hidden$="[[shouldHideJumpButton(payWeekData, liveIsoDate)]]"
          on-click="jumpToToday"
          >Today</katapult-button
        >
        <material-icon icon="chevron_left" class="arrowButton" data-offset="-7" on-click="updateWeekPointer"></material-icon>
        <span style="text-align: center; text-transform: uppercase; width: 200px">[[getDateRangeString(currentMonday, 'DATE_MED')]]</span>
        <material-icon icon="chevron_right" class="arrowButton" data-offset="7" on-click="updateWeekPointer"></material-icon>
      </span>
    `;
  }

  static get disabledMessageTemplate() {
    return html`
      <style>
        .migrationMessage {
          font-size: 24px;
          border-radius: 16px;
          background-color: white;
          padding: 16px;
          margin: 20px;
          text-align: center;
          border: 3px solid #ff8300;
          color: #ff8300;
        }
      </style>
      <div class="migrationMessage">
        <p>
          <strong>Important:</strong> Timesheet data has now migrated to the DCS database. Please use the alpha DCS domain during this
          transition.
        </p>
        <p>
          <a style="color: inherit" href="https://alpha.dcs.katapultpro.com/home">https://alpha.dcs.katapultpro.com/home</a>
        </p>
      </div>
    `;
  }

  static get bodyTemplate() {
    return html`
      <style include="paper-table-style">
        [hidden] {
          display: none;
        }
        [invisible] {
          pointer-events: none;
          opacity: 0;
        }
        [flex-row] {
          display: flex;
          flex-direction: row;
        }
        [flex-column] {
          display: flex;
          flex-direction: column;
        }
        paper-cell[faded] {
          color: var(--primary-text-color-faded);
        }
        katapult-button {
          text-align: center;
        }
        .payWeekTable paper-cell {
          padding: 6px;
        }
        .pay-week-column {
          flex: 1 1 0;
          min-width: 0;
        }
        #mainTable .pay-week-column:not(:last-of-type) paper-cell {
          border-right: 1px solid rgba(0 0 0 / 6%);
        }
        #mainTable {
          flex-direction: row;
        }
        #wrapper {
          border: 1px solid var(--paper-grey-300);
          border-radius: 16px;
          background-color: #fff;
        }
        #widgetBody {
          padding: 12px;
        }
        #widgetHeader {
          justify-content: space-between;
        }
        .section {
          display: flex;
          gap: 24px;
          flex-wrap: wrap;
        }
        #widgetTitle {
          font-size: 14pt;
          color: #424242;
        }
        .dayHeader {
          font-size: 12px;
          justify-content: center;
          white-space: nowrap;
          overflow: hidden;
        }
        .dayHeader[highlighted] span {
          color: #fff;
          padding: 2px 4px;
          border-radius: 8px;
        }
        #mainTable .dayHeader[highlighted] span {
          background-color: var(--paper-green-500);
        }
        .payWeekTable {
          overflow: hidden;
          box-sizing: border-box;
        }
        .weekday-button {
          color: var(--paper-grey-400);
          border: 2px solid var(--paper-grey-400);
          height: 42px;
          border-radius: 16px;
          margin: 0;
          display: inline-block;
          padding: 0;
          min-width: 0;
          flex: 1;
          text-align: center;
          display: flex;
          font-size: 18px;
          transition: box-shadow 0.2s ease;
        }
        .weekday-button:hover {
          box-shadow: 0 0 8px rgba(0 0 0 / 50%);
          z-index: 1;
        }
        .weekday-button-locked {
          opacity: 0.7;
          font-style: italic;
        }
        .weekday-button-saved {
          color: var(--paper-green-500);
          border: 2px solid var(--paper-green-500);
        }
        .weekday-button-saved-weekend {
          color: var(--secondary-color);
          border: 2px solid var(--secondary-color);
        }
        .weekday-button-submitted {
          color: #fff;
          background-color: var(--paper-green-500);
          border: none;
        }
        .weekday-button-submitted-weekend {
          color: #fff;
          background-color: var(--secondary-color);
          border: none;
        }
        .arrowButton {
          color: var(--secondary-color);
          cursor: pointer;
          user-select: none;
          -webkit-user-select: none; /* Safari */
        }
        .sectionHeader {
          margin-bottom: 12px;
        }
        .header-text,
        .sectionHeader > span:first-of-type {
          font-size: 14pt;
          color: var(--primary-text-color-faded);
        }
        .markerDot {
          width: 10px;
          height: 10px;
          border-radius: 100%;
          margin-right: 8px;
        }
        .allocationName {
          font-weight: bold;
          font-size: 16px;
          color: var(--primary-text-color-faded);
        }
        .allocationLabelContainer {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: row;
          margin-bottom: var(--sl-spacing-medium);
        }
        .allocationPercent {
          flex: 1;
          font-weight: bold;
          font-size: 32px;
          color: var(--primary-text-color-faded);
        }
        .buttonWithIcon {
          position: relative;
          padding-left: 36px;
        }
        .buttonWithIcon > material-icon {
          position: absolute;
          left: 8px;
        }
        .dayLabel {
          font-size: 12px;
          margin-bottom: 6px;
          padding: 2px 4px;
          border-radius: 8px;
        }
        .dayLabel[highlighted] {
          color: #fff;
          background-color: var(--secondary-color);
        }
        .payWeekTable paper-cell:not(:first-of-type) {
          border-left: 1px solid rgba(0 0 0 / 6%);
        }
        .tooltipAnchor {
          display: inline-flex;
          vertical-align: middle;
        }
        #tooltip {
          position: fixed;
          background-color: #fff;
          box-sizing: border-box;
          border: 2px solid rgba(0 0 0 / 6%);
          border-radius: 0 16px 16px 16px;
          z-index: 9001;
          padding: 6px;
          white-space: pre-wrap;
          max-width: 550px;
          font-size: 14px;
          transition-property: opacity;
          transition-duration: 0.25s;
        }
        paper-slider[invalid] {
          --paper-slider-container-color: var(--error-color);
        }
        #reviewSubmitTimesheet [slot='title'],
        #timeEntryDialog [slot='title'] {
          text-transform: uppercase;
          font-weight: 400;
        }
        #viewingAs {
          padding: 0px 8px;
          border-radius: 8px;
          background-color: var(--secondary-color);
          color: white;
        }
        .note {
          border-radius: 16px;
          background-color: var(--paper-grey-200);
          padding: 16px;
        }
        #main {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        #main .note {
          color: var(--paper-green-500);
        }
        @media screen and (max-width: 600px) {
          #widgetHeader {
            flex-wrap: wrap;
            height: unset;
          }
          #mainTable {
            flex-direction: column;
          }
          .payWeekTable {
            overflow-x: auto; /* test */
            flex-wrap: nowrap; /* test */
          }
          #primaryControl {
            flex-grow: 2.5;
          }
          #primControlText {
            font-size: 10pt;
          }
        }
        .faces {
          height: 55px;
          width: auto;
          cursor: pointer;
        }
        .faces:hover {
          height: 75px;
          width: auto;
          cursor: pointer;
        }
        .notActive {
          color: #9e9e9e !important;
        }
        #verySad {
          color: #b71c1c;
        }
        #sad {
          color: #ff6f00;
        }
        #neutral {
          color: #ffab00;
        }
        #happy {
          color: #8bc34a;
        }
        #veryHappy {
          color: #2e7d32;
        }
        .missing {
          color: red;
        }
        .notMissing {
          color: black;
        }
        .dateChooser {
          width: 125px;
          display: inline-block;
          margin-left: 10px;
        }
        .dialogBody {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
      </style>
      <span hidden$="[[!selectedUid]]" id="viewingAs">(Viewing as [[of(allUsersData, selectedUid, 'email')]])</span>
      <div style="display: flex; flex-direction: column; gap: 24px;">
        <div class="section">
          <div id="main">
            <div flex-row style="justify-content: space-between; align-items: center;">
              <div class="header-text">Submit Timesheet Hours</div>
              <!-- SUBMIT / APPEND / VIEW -->
              <div flex-row style="justify-content: right; gap: 8px; align-items: center; flex-wrap: wrap;">
                <div flex-row style="gap: 8px;">
                  <katapult-icon
                    icon="check_circle"
                    color="var(--paper-green-500)"
                    hidden$="[[!timesheetStatus.submitted]]"
                    title="Timesheet has been submitted for payroll"
                  ></katapult-icon>
                  <katapult-icon
                    icon="check_circle"
                    color="var(--secondary-color)"
                    hidden$="[[!timesheetStatus.appended]]"
                    title="Timesheet has been appended since submission"
                  ></katapult-icon>
                  <katapult-icon
                    icon="lock"
                    color="var(--paper-red-500)"
                    hidden$="[[!timesheetStatus.locked]]"
                    title="Timesheet has been locked"
                  ></katapult-icon>
                </div>

                <template is="dom-if" if="[[!timesheetStatus.submitted]]">
                  <katapult-button id="submit" color="var(--paper-green-500)" on-click="promptReviewSubmitTimesheet"
                    >Review & Submit</katapult-button
                  >
                </template>

                <template is="dom-if" if="[[timesheetStatus.submitted]]">
                  <template is="dom-if" if="[[!timesheetStatus.locked]]">
                    <katapult-button id="append" color="var(--secondary-color)" on-click="promptReviewSubmitTimesheet"
                      >View & Append</katapult-button
                    >
                  </template>

                  <template is="dom-if" if="[[timesheetStatus.locked]]">
                    <katapult-button color="var(--paper-grey-500)" on-click="promptReviewSubmitTimesheet">View Summary</katapult-button>
                  </template>
                </template>
              </div>
            </div>

            <paper-table class="payWeekTable" id="mainTable" outline dividers rounded style="flex: 1;">
              <template is="dom-repeat" items="[[payWeekData]]">
                <div class="pay-week-column">
                  <paper-row header short grey>
                    <paper-cell class="dayHeader" highlighted$="[[shouldHighlight(item, liveIsoDate)]]" weekday$="[[item.weekday]]">
                      <span>[[item.weekday]]</span>
                    </paper-cell>
                  </paper-row>
                  <paper-row expand>
                    <paper-cell flex-column style="align-items: center;" weekday$="[[item.weekday]]">
                      <span class="dayLabel">[[item.label]]</span>
                      <div flex-row style="width: 100%;">
                        <katapult-button class$="[[getWeekdayButtonClasses(item)]]" data-table="main" on-click="promptTimeEntryDialog"
                          >[[toTimeString(item.hours.default)]]</katapult-button
                        >
                      </div>
                    </paper-cell>
                  </paper-row>
                </div>
              </template>
            </paper-table>
            <div class="note">
              Record your hours daily. Submit your hours when you are finished working for the week. If you make a mistake or work
              additional hours after submitting, you can append these submitted hours up until 9am Monday.
              <strong>All submissions are locked at 9am Monday.</strong>
            </div>
          </div>
        </div>

        <div class="section">
          <div flex-column style="flex: 1;">
            <div class="sectionHeader" flex-row style="justify-content: left; gap: 8px; align-items: center;">
              <span>Quick Summary</span>
            </div>
            <div style="color: var(--primary-text-color-faded); font-weight: bold; text-align: center;">
              Total: [[weeklyGrandTotal]] hrs
            </div>
            <div style="display: flex; justify-content: center;">
              <canvas id="weekTotalsPieChart" width="250" height="250"></canvas>
            </div>
          </div>
          <template is="dom-if" if="[[timesheetOptions.allow_pto_reporting]]">
            <template is="dom-if" if="[[fullTimeEmployee]]">
              <div style="flex: 1.5;">
                <div class="sectionHeader" flex-row style="justify-content: left;">
                  <span>Yearly Paid Time Off (PTO) Hours</span>
                </div>
                <paper-table class="payWeekTable" outline dividers rounded style="flex: 1.5;">
                  <paper-row header short grey>
                    <paper-cell class="dayHeader"></paper-cell>
                    <paper-cell class="dayHeader">
                      <span>Allotted</span>
                    </paper-cell>
                    <paper-cell class="dayHeader">
                      <span>Used</span>
                    </paper-cell>
                    <paper-cell class="dayHeader">
                      <span>Remaining</span>
                    </paper-cell>
                  </paper-row>

                  <paper-row expand>
                    <paper-cell class="dayHeader">
                      <span>Vacation</span>
                    </paper-cell>
                    <paper-cell flex-column style="align-items: center;">
                      <div flex-row style="width: 100%;">
                        <!-- Click to see how time allotted is calculated-->
                        <katapult-button class="weekday-button" on-click="promptVacationAllottedDialog"
                          >[[userPtoData.vacAllotted]]</katapult-button
                        >
                      </div>
                    </paper-cell>
                    <paper-cell flex-column style="align-items: center;">
                      <div flex-row style="width: 100%;">
                        <!-- Click to see dates where time off was used-->
                        <katapult-button class="weekday-button" on-click="promptVacationUsedDialog"
                          >[[userPtoData.vacUsedTotal]]</katapult-button
                        >
                      </div>
                    </paper-cell>
                    <paper-cell flex-column style="align-items: center;">
                      <div flex-row style="width: 100%;">
                        <!-- Click to see suggestions for vacation day usage, and a reminder that vacation days do not save between years-->
                        <katapult-button class="weekday-button" on-click="promptVacationRemainingDialog"
                          >[[userPtoData.vacRemaining]]</katapult-button
                        >
                      </div>
                    </paper-cell>
                  </paper-row>

                  <paper-row expand>
                    <paper-cell class="dayHeader">
                      <span>Sick</span>
                    </paper-cell>
                    <paper-cell flex-column style="align-items: center;">
                      <div flex-row style="width: 100%;">
                        <!-- Click to see note about Katapult's sick leave policy-->
                        <katapult-button class="weekday-button" on-click="promptSickLeaveDialog">
                          <span style="font-size:15px;">as needed</span>
                        </katapult-button>
                      </div>
                    </paper-cell>
                    <paper-cell flex-column style="align-items: center;">
                      <!-- Click to see dates where time off was used-->
                      <div flex-row style="width: 100%;">
                        <katapult-button class="weekday-button" on-click="promptSickLeaveUsedDialog"
                          >[[userPtoData.sickTakenTotal]]</katapult-button
                        >
                      </div>
                    </paper-cell>
                    <paper-cell flex-column style="align-items: center;">
                      <div flex-row style="width: 100%;">
                        <!-- Click to see note about Katapult's sick leave policy-->
                        <katapult-button class="weekday-button" on-click="promptSickLeaveDialog">
                          <span style="font-size:15px;">as needed</span>
                        </katapult-button>
                      </div>
                    </paper-cell>
                  </paper-row>

                  <paper-row expand>
                    <paper-cell class="dayHeader">
                      <span>Family Care</span>
                    </paper-cell>
                    <paper-cell flex-column style="align-items: center;">
                      <div flex-row style="width: 100%;">
                        <!-- Click to see description of Family Care Leave-->
                        <katapult-button class="weekday-button" on-click="promptAllottedFamilyCareDialog"
                          >[[userPtoData.famCareAllotted]]</katapult-button
                        >
                      </div>
                    </paper-cell>
                    <paper-cell flex-column style="align-items: center;">
                      <div flex-row style="width: 100%;">
                        <!-- Click to see dates where time off was used-->
                        <katapult-button class="weekday-button" on-click="promptUsedFamilyCareDialog"
                          >[[userPtoData.famCareUsedTotal]]</katapult-button
                        >
                      </div>
                    </paper-cell>
                    <paper-cell flex-column style="align-items: center;">
                      <div flex-row style="width: 100%;">
                        <!-- Click to see description of Family Care Leave-->
                        <katapult-button class="weekday-button" on-click="promptAllottedFamilyCareDialog"
                          >[[userPtoData.famCareRemaining]]</katapult-button
                        >
                      </div>
                    </paper-cell>
                  </paper-row>
                </paper-table>
              </div>
            </template>
          </template>
        </div>
      </div>

      <!-- ADMIN LAYER -->
      <template is="dom-if" if="[[userIsTimesheetManager]]" restamp>
        <div style="padding-top: 8px; border-top: solid 1px rgba(0 0 0 / 12%); margin-top: 10px;">
          <div flex-row style="justify-content: space-between;">
            <div flex-row style="align-items: center;">
              <katapult-button color="var(--secondary-color)" style="margin-right: 12px;" on-click="promptExportDialog"
                >Export Data</katapult-button
              >
              <katapult-drop-down
                label="View as User"
                no-label-float
                style="margin-right: 12px;"
                items="[[usernames]]"
                label-path="email"
                value-path="uid"
                on-click="loadNames"
                on-selected-changed="adminUpdateUid"
              ></katapult-drop-down>
              <sl-tooltip
                content="Lock this user's timesheet for this week: ([[getDateRangeString(currentMonday, 'DATE_SHORT')]])"
                placement="top"
              >
                <katapult-button
                  color="var(--secondary-color)"
                  class="buttonWithIcon"
                  hidden$="[[payWeekData.0.isLocked]]"
                  on-click="toggleLockTimesheet"
                >
                  <material-icon icon="lock"></material-icon>
                  <span>Lock</span>
                </katapult-button>
              </sl-tooltip>
              <sl-tooltip
                content="Unlock this user's timesheet for this week: ([[getDateRangeString(currentMonday, 'DATE_SHORT')]])"
                placement="top"
              >
                <katapult-button
                  color="var(--secondary-color)"
                  class="buttonWithIcon"
                  hidden$="[[!payWeekData.0.isLocked]]"
                  on-click="toggleLockTimesheet"
                >
                  <material-icon icon="lock_open"></material-icon>
                  <span>Unlock</span>
                </katapult-button>
              </sl-tooltip>
              <sl-tooltip
                content="Lock timesheets for all users this week: ([[getDateRangeString(currentMonday, 'DATE_SHORT')]])"
                placement="top"
              >
                <katapult-button color="var(--secondary-color)" style="margin: 4px;" class="buttonWithIcon" on-click="lockThisWeek">
                  <material-icon icon="lock"></material-icon>
                  <span>Lock This Week</span>
                </katapult-button>
              </sl-tooltip>
            </div>
          </div>
          <template is="dom-if" if="[[timesheetOptions.allow_pto_reporting]]">
            <div flex-row style="justify-content: space-between; margin-top: 10px;">
              <div flex-row style="align-items: center;">
                <katapult-button color="var(--secondary-color)" style="margin-right: 12px;" on-click="adminDataUpdate" data-type="vacation"
                  >Update Allotted Vacation</katapult-button
                >
                <paper-input
                  class="allocationHoursInput"
                  label="0:00"
                  allowed-pattern="[0-9.:]"
                  no-label-float=""
                  style="width: 80px;"
                  value="{{adminVacAllotted}}"
                  tabindex="0"
                  aria-disabled="false"
                >
                  <span slot="suffix" style="margin-left: 8px;">hrs</span>
                </paper-input>
                <!-- <template is="dom-if" if="[[manualChange]]"> -->
                <katapult-button
                  color="var(--secondary-color)"
                  style="margin-left: 12px;"
                  on-click="unlockAllottedVacationCalc"
                  data-type="vacation"
                  >Revert to Autocalculated Value</katapult-button
                >
                <!-- </template> -->
              </div>
            </div>
            <div flex-row style="justify-content: space-between; margin-top: 10px;">
              <div flex-row style="align-items: center;">
                <katapult-button color="var(--secondary-color)" style="margin-right: 12px;" on-click="adminDataUpdate" data-type="fcl"
                  >Update Allotted Family Care Leave</katapult-button
                >
                <paper-input
                  class="allocationHoursInput"
                  label="0:00"
                  allowed-pattern="[0-9.:]"
                  no-label-float=""
                  style="width: 80px;"
                  value="{{adminFamCareAllotted}}"
                  tabindex="0"
                  aria-disabled="false"
                >
                  <span slot="suffix" style="margin-left: 8px;">hrs</span>
                </paper-input>
              </div>
            </div>
          </template>
        </div>
      </template>

      <!-- LMA Admins Only -->
      <template is="dom-if" if="[[or(teamsUserIsLeaderOf.length, userIsTimesheetManager)]]" restamp>
        <div style="padding-top: 8px; border-top: solid 1px rgba(0 0 0 / 12%); margin-top: 10px;">
          <div flex-row style="justify-content: space-between;">
            <div flex-row style="align-items: center;">
              <katapult-button color="var(--secondary-color)" style="margin-right: 12px;" on-click="promptExportDialogLMA"
                >Export Team Timesheet Data</katapult-button
              >
            </div>
          </div>
        </div>
      </template>

      <!-- DIALOGS -->
      <!-- Time Entry-->
      <katapult-dialog title="[[timeEntryDialogTitle]]" id="timeEntryDialog" no-cancel-on-outside-click closeButton>
        <div flex-column style="max-width: 500px;">
          <div class="sectionHeader" flex-row style="justify-content: space-between; align-items: center;">
            <span>Hours</span>
            <template is="dom-if" if="[[timesheetOptions.allow_pto_reporting]]">
              <template is="dom-if" if="[[overheadTimeClasses.length]]">
                <katapult-drop-down
                  items="[[filteredOverheadTimeClasses]]"
                  label-path="name"
                  secondary-label-path="sublabel"
                  label="Add Allocations"
                  no-label-float
                  disabled="[[timesheetStatus.locked]]"
                  on-selected-will-change="addAllocation"
                ></katapult-drop-down>
              </template>
            </template>
          </div>
          <template is="dom-if" if="[[timesheetStatus.submitted]]">
            <p>
              Amending an already-submitted timesheet will notify the payroll administrator, but you should reach out to them directly as
              well.
            </p>
          </template>
          <template is="dom-if" if="[[timesheetStatus.locked]]">
            <p>
              This day was locked by the payroll administrator and can no longer be modified. Contact them directly if you need to amend
              your timesheet.
            </p>
          </template>
          <paper-table id="timeClassAllocations" outline dividers rounded style="overflow: hidden;">
            <template is="dom-repeat" items="[[timeClasses]]" as="timeClass" mutable-data>
              <paper-row expand>
                <paper-cell class="timeClassName" flex-column style="justify-content: center; align-items: flex-start;">
                  <div class="allocationLabelContainer">
                    <template is="dom-if" if="[[timeClass.archived]]">
                      <sl-tooltip placement="bottom" hoist content="This category has been archived">
                        <katapult-icon icon="archive" style="margin-right: var(--sl-spacing-small)"></katapult-icon>
                      </sl-tooltip>
                    </template>
                    <div class="allocationName">[[firstValid(timeClass.description, timeClass.name)]]</div>
                  </div>
                  <div>[[timeClass.sublabel]]</div>
                </paper-cell>
                <paper-cell flex-column style="align-items: flex-start;">
                  <div flex-row style="align-items: center; width: 100%; gap: 8px;">
                    <div class="allocationPercent">[[toPercent(timeClass.hours, totalHours)]]</div>
                    <paper-input
                      class="allocationHoursInput"
                      allowed-pattern="[0-9.:]"
                      no-label-float
                      style="width: 80px;"
                      readonly="[[timesheetStatus.locked]]"
                      disabled="[[timeClass.archived]]"
                      value="[[timeClass._hours]]"
                      data-path="timeClasses.$index._hours"
                      on-blur="updateHours"
                      on-keydown="maybeUpdateHours"
                      on-click="selectAllText"
                    >
                      <span slot="suffix" style="margin-left: 8px;">hrs</span>
                    </paper-input>
                  </div>
                  <paper-input
                    class="allocationNoteInput"
                    placeholder="Note"
                    style="width: 100%;"
                    no-label-float
                    readonly="[[timesheetStatus.locked]]"
                    disabled="[[timeClass.archived]]"
                    value="[[timeClass.note]]"
                    data-path="timeClasses.$index.note"
                    on-value-changed="setProperty"
                  ></paper-input>
                </paper-cell>
              </paper-row>
            </template>
            <paper-row grey>
              <paper-cell style="font-weight: bold; font-size: 16px;">TOTAL</paper-cell>
              <paper-cell style="font-weight: bold; font-size: 16px; justify-content: flex-end;"
                >[[toTimeString(totalHours)]] hrs</paper-cell
              >
            </paper-row>
          </paper-table>
        </div>
        <template is="dom-if" if="[[!timesheetStatus.locked]]">
          <div slot="buttons">
            <div hidden="[[validHours]]" style="color: var(--error-color);">
              The time you entered is not in 15 minute increments. Please review your hours.
            </div>
            <katapult-button color="var(--secondary-color)" on-click="saveDay" disabled$="[[selectedUid]]" style="float: right;"
              >[[ifElse(timesheetStatus.submitted, 'Append', 'Save')]]</katapult-button
            >
          </div>
        </template>
      </katapult-dialog>

      <!-- Review & Submit Timesheet -->
      <katapult-dialog id="reviewSubmitTimesheet" title="[[reviewDialogTitle]]" closeOnOutsideClick width="700">
        <div style="flex-wrap: wrap" flex-row>
          <!-- Left column -->
          <div style="flex: 1.25; margin-right: 6px;">
            <paper-table outline dividers rounded style="overflow: hidden; margin-bottom: 12px;">
              <paper-row header short grey>
                <paper-cell>Date</paper-cell>
                <paper-cell>Day</paper-cell>
                <paper-cell>Worked</paper-cell>
                <template is="dom-if" if="[[timesheetOptions.allow_pto_reporting]]">
                  <paper-cell>PTO</paper-cell>
                </template>
                <paper-cell hidden$="[[!payCycleTotals.partTimeSecondary]]">PTS</paper-cell>
              </paper-row>
              <template is="dom-repeat" items="[[payCycleBreakdown]]">
                <paper-row>
                  <paper-cell>[[item.date]]</paper-cell>
                  <paper-cell>[[item.weekday]]</paper-cell>
                  <paper-cell faded$="[[!item.hoursWorked]]">[[toTimeString(item.hoursWorked)]]</paper-cell>
                  <template is="dom-if" if="[[timesheetOptions.allow_pto_reporting]]">
                    <paper-cell faded$="[[!item.paidTimeOff]]">[[toTimeString(item.paidTimeOff)]]</paper-cell>
                  </template>
                  <paper-cell hidden$="[[!payCycleTotals.partTimeSecondary]]" faded$="[[!item.partTimeSecondary]]"
                    >[[toTimeString(item.partTimeSecondary)]]</paper-cell
                  >
                </paper-row>
              </template>
              <paper-row grey expand>
                <paper-cell>TOTALS</paper-cell>
                <paper-cell></paper-cell>
                <paper-cell>[[toTimeString(payCycleTotals.hoursWorked)]]</paper-cell>
                <template is="dom-if" if="[[timesheetOptions.allow_pto_reporting]]">
                  <paper-cell>[[toTimeString(payCycleTotals.paidTimeOff)]]</paper-cell>
                </template>
                <paper-cell hidden$="[[!payCycleTotals.partTimeSecondary]]">[[toTimeString(payCycleTotals.partTimeSecondary)]]</paper-cell>
              </paper-row>
            </paper-table>

            <paper-table outline dividers rounded style="overflow: hidden; flex: 1; height: fit-content;">
              <paper-row header short grey>
                <paper-cell>Type</paper-cell>
                <paper-cell>Units</paper-cell>
              </paper-row>
              <paper-row>
                <paper-cell>
                  <span>
                    Regular
                    <span hidden$="[[!timesheetOptions.regular_work_week_hours]]">([[timesheetOptions.regular_work_week_hours]])</span>
                  </span>
                </paper-cell>
                <paper-cell>[[toTimeString(payCycleTotals.regular)]]</paper-cell>
              </paper-row>
              <paper-row hidden$="[[userData.employment.salaried]]">
                <paper-cell>OT</paper-cell>
                <paper-cell>[[toTimeString(payCycleTotals.overtime)]]</paper-cell>
              </paper-row>
              <template is="dom-if" if="[[timesheetOptions.allow_pto_reporting]]">
                <paper-row>
                  <paper-cell>PTO</paper-cell>
                  <paper-cell>[[toTimeString(payCycleTotals.paidTimeOff)]]</paper-cell>
                </paper-row>
              </template>
              <paper-row hidden$="[[!payCycleTotals.partTimeSecondary]]">
                <paper-cell>PTS</paper-cell>
                <paper-cell>[[toTimeString(payCycleTotals.partTimeSecondary)]]</paper-cell>
              </paper-row>
              <paper-row grey>
                <paper-cell>TOTAL</paper-cell>
                <paper-cell>[[toTimeString(payCycleTotals.grandTotal)]]</paper-cell>
              </paper-row>
            </paper-table>
          </div>

          <!-- Right Column -->
          <div style="padding-left: 12px; box-sizing: border-box; flex: 1;">
            <iron-form id="timesheetSubmissionForm">
              <form>
                <template is="dom-if" if="[[timesheetOptions.allow_bonus_reporting]]">
                  <p>Self-report your weekly bonus below, if applicable.</p>
                  <paper-input
                    label="Amount"
                    allowed-pattern="[0-9.]"
                    value="[[timesheetMetadata.bonus]]"
                    readonly="[[timesheetStatus.locked]]"
                    data-path="timesheetMetadata.bonus"
                    on-value-changed="setProperty"
                  >
                    <span slot="prefix" style="margin-right: 6px;">$</span>
                  </paper-input>
                  <paper-textarea
                    label="Bonus Description"
                    value="[[timesheetMetadata.bonusNote]]"
                    readonly="[[timesheetStatus.locked]]"
                    data-path="timesheetMetadata.bonusNote"
                    on-value-changed="setProperty"
                  ></paper-textarea>
                </template>
                <div class="sectionHeader" style="margin-top: 12px;">
                  <span>Team Health</span>
                </div>
                <p id="labelEmotions">
                  <span style="white-space: pre-line;">[[teamHealthRatingSystemText]]</span>
                  <template is="dom-if" if="[[teamHealthRatingSystemTooltip]]">
                    <sl-tooltip placement="bottom">
                      <material-icon
                        class="tooltipAnchor"
                        icon="help"
                        size="small"
                        style="cursor: default;"
                        data-copy="general"
                      ></material-icon>
                      <div slot="content" style="background: none; white-space: pre-line;">[[teamHealthRatingSystemTooltip]]</div>
                    </sl-tooltip>
                  </template>
                </p>
                <paper-table>
                  <paper-row on-click="setGrowthRating">
                    <iron-icon icon="social:sentiment-very-dissatisfied" name="1" class="faces" id="verySad"></iron-icon>
                    <iron-icon icon="social:sentiment-dissatisfied" name="2" class="faces" id="sad"></iron-icon>
                    <iron-icon icon="social:sentiment-neutral" name="3" class="faces" id="neutral"></iron-icon>
                    <iron-icon icon="social:sentiment-satisfied" name="4" class="faces" id="happy"></iron-icon>
                    <iron-icon icon="social:sentiment-very-satisfied" name="5" class="faces" id="veryHappy"></iron-icon>
                  </paper-row>
                </paper-table>
                <p style="margin: 16px 0;">
                  <span style="white-space: pre-line;">[[teamHealthNotesText]]</span>
                  <template is="dom-if" if="[[teamHealthNotesTooltip]]">
                    <sl-tooltip placement="bottom">
                      <material-icon
                        class="tooltipAnchor"
                        icon="help"
                        size="small"
                        style="cursor: default;"
                        data-copy="general"
                      ></material-icon>
                      <div slot="content" style="background: none; white-space: pre-line;">[[teamHealthNotesTooltip]]</div>
                    </sl-tooltip>
                  </template>
                </p>
                <paper-textarea
                  label="Notes from the Week"
                  value="[[timesheetMetadata.generalNote]]"
                  readonly="[[timesheetStatus.locked]]"
                  required
                  data-path="timesheetMetadata.generalNote"
                  on-value-changed="setProperty"
                ></paper-textarea>
                <div flex-row style="margin: 16px 0; align-items: center;">
                  <paper-checkbox
                    checked="[[timesheetMetadata.legalAgreed]]"
                    required
                    data-path="timesheetMetadata.legalAgreed"
                    disabled="[[timesheetStatus.locked]]"
                    on-checked-changed="setProperty"
                  ></paper-checkbox>
                  <span>
                    <span style="white-space: pre-line;">[[submissionVerificationText]]</span>
                    <template is="dom-if" if="[[submissionVerificationTooltip]]">
                      <sl-tooltip placement="bottom">
                        <material-icon
                          class="tooltipAnchor"
                          icon="help"
                          size="small"
                          style="cursor: default;"
                          data-copy="legal"
                        ></material-icon>
                        <div slot="content" style="background: none; white-space: pre-line;">[[submissionVerificationTooltip]]</div>
                      </sl-tooltip>
                    </template>
                  </span>
                </div>
              </form>
            </iron-form>
          </div>
          <div id="tooltip" invisible$="[[tooltipIsInvisible]]"></div>
        </div>
        <div slot="buttons" flex-row style="width: 100%; justify-content: space-between;">
          <katapult-button dialog-dismiss>Cancel</katapult-button>
          <div flex-row style="gap: 8px;">
            <katapult-button
              disabled="[[timesheetStatus.locked]]"
              color="var(--secondary-color)"
              outlined
              data-action="submit-save"
              data-submission-type="partial"
              on-click="submitTimesheet"
              >Save Changes</katapult-button
            >
            <katapult-button
              disabled="[[timesheetStatus.locked]]"
              color="var(--secondary-color)"
              data-action="submit"
              data-submission-type="full"
              on-click="submitTimesheet"
              >[[ifElse(timesheetStatus.submitted, 'Append to Timesheet', 'Submit Timesheet')]]</katapult-button
            >
          </div>
        </div>
      </katapult-dialog>

      <!-- Export Dialog -->
      <katapult-dialog-legacy id="exportDialog" style="width: 500px;" no-cancel-on-outside-click close-button>
        <span slot="title">Export Timesheet Data</span>
        <div slot="body" flex-column>
          <template is="dom-if" if="[[exportWarnings.length]]">
            <div style="background-color: var(--paper-orange-100); padding: 12px; border-radius: 16px; margin-bottom: 12px;">
              <div><b>Warning</b>: The following issues were found during the export:</div>
              <ul style="margin-bottom: 0; display: flex; flex-direction: column; gap: 8px; padding-left: 24px;">
                <template is="dom-repeat" items="[[exportWarnings]]">
                  <li>[[item]]</li>
                </template>
              </ul>
            </div>
          </template>
          <!-- Payroll Export -->
          <div class="sectionHeader">
            <span>Payroll Export</span>
            <span>([[getDateRangeString(currentMonday, 'DATE_SHORT')]])</span>
          </div>
          <div style="margin-bottom: 12px;">
            <katapult-button color="var(--secondary-color)" style="margin: 4px;" data-export-type="payroll-1" on-click="exportTimesheetData"
              >Payroll Data (1 week)</katapult-button
            >
            <katapult-button color="var(--secondary-color)" style="margin: 4px;" data-export-type="payroll-2" on-click="exportTimesheetData"
              >Payroll Data (2 weeks)</katapult-button
            >
            <katapult-button
              color="var(--secondary-color)"
              data-export-type="payroll-range"
              callback="exportTimesheetData"
              style="margin: 4px;"
              >Payroll Data (Range)</katapult-button
            >
            <div class="sectionHeader">
              <span>Payroll Data (Range)</span>
              <paper-input class="dateChooser" label="Start Date" value="{{exportStartDate}}" type="date"></paper-input>
              <paper-input class="dateChooser" label="End Date" value="{{exportEndDate}}" type="date"></paper-input>
            </div>
            <katapult-button color="var(--secondary-color)" data-export-type="survey" on-click="exportTimesheetData"
              >End Of Week Surveys</katapult-button
            >
          </div>
          <!-- KP Export -->
          <div class="sectionHeader">
            <span>KP Export</span>
            <span>([[getDateRangeString(previousMonday, 'DATE_SHORT', 7)]])</span>
          </div>
          <div style="margin-bottom: 12px;">
            <katapult-button color="var(--secondary-color)" data-export-type="kp" on-click="exportTimesheetData">KP Data</katapult-button>
          </div>
          <!-- Unpaid Leave Export -->
          <div class="sectionHeader">
            <span>Unpaid Leave Export</span>
            <paper-input class="dateChooser" label="Start Date" value="{{exportStartDate}}" type="date"></paper-input>
            <paper-input class="dateChooser" label="End Date" value="{{exportEndDate}}" type="date"></paper-input>
          </div>
          <div style="margin-bottom: 12px;">
            <katapult-button color="var(--secondary-color)" data-export-type="unpaid-leave" on-click="exportTimesheetData"
              >Unpaid Leave Data</katapult-button
            >
          </div>
        </div>
      </katapult-dialog-legacy>

      <katapult-dialog id="exportDialogLMA" title="Export Team Timesheet Data" width="500" closeButton>
        <div flex-column style="gap: 24px;">
          <template is="dom-if" if="[[exportWarnings.length]]">
            <div style="background-color: var(--paper-orange-100); padding: 12px; border-radius: 16px; margin-bottom: 12px;">
              <div><b>Warning</b>: The following issues were found during the export:</div>
              <ul style="margin-bottom: 0; display: flex; flex-direction: column; gap: 8px; padding-left: 24px;">
                <template is="dom-repeat" items="[[exportWarnings]]">
                  <li>[[item]]</li>
                </template>
              </ul>
            </div>
          </template>

          <div>
            <div>Team</div>
            <div>
              <template is="dom-if" if="[[greaterThan(teamsUserIsLeaderOf.length, 1)]]">
                <div style="padding: 8px 0;">
                  <paper-checkbox checked="{{exportAllTeamsLedByUser}}" disabled="[[exportAllTeams]]"
                    >Export data for all teams I lead</paper-checkbox
                  >
                </div>
              </template>
              <template is="dom-if" if="[[userIsTimesheetManager]]">
                <div style="padding: 8px 0;">
                  <paper-checkbox checked="{{exportAllTeams}}" disabled="[[exportAllTeamsLedByUser]]"
                    >Export data for all teams</paper-checkbox
                  >
                </div>
              </template>
              <katapult-drop-down
                label="Select Team"
                no-label-float
                items="[[teamsUserIsLeaderOf]]"
                label-path="1.name"
                value-path="0"
                disabled="[[or(exportAllTeams, exportAllTeamsLedByUser)]]"
                value="{{selectedTeamForExport}}"
              ></katapult-drop-down>
            </div>
          </div>

          <div>
            <div>Work Week Base Hours</div>
            <div>
              <paper-input
                class="allocationHoursInput"
                label="0:00"
                allowed-pattern="[0-9.:]"
                no-label-float=""
                style="width: 80px;"
                value="{{workWeekHours}}"
                tabindex="0"
                aria-disabled="false"
                ><span slot="suffix" style="margin-left: 8px;">hrs</span>
              </paper-input>
            </div>
          </div>

          <div>
            <div>Date Range</div>
            <div>
              <paper-input class="dateChooser" label="Start Date" value="{{exportStartDate}}" type="date"></paper-input>
              <paper-input class="dateChooser" label="End Date" value="{{exportEndDate}}" type="date"></paper-input>
              <katapult-button style="margin-left: 8px;" color="var(--paper-grey-200)" size="small" on-click="resetExportDateRange"
                >Set to last week</katapult-button
              >
            </div>
          </div>
        </div>
        <katapult-button slot="buttons" color="var(--secondary-color)" data-export-type="team-data" on-click="exportTimesheetData"
          >Export</katapult-button
        >
      </katapult-dialog>

      <!-- Vacation Used Dialog -->
      <katapult-dialog id="vacationUsedDialog" closeOnEscape closeOnOutsideClick closeButton maxwidth="600">
        <div slot="title">Vacation</div>
        <div class="dialogBody" flex-column>
          <div>Vacation time used this year so far:</div>
          <paper-table class="payWeekTable" outline dividers rounded style="flex: 1;">
            <paper-row header short grey>
              <paper-cell class="dayHeader"><span>Date</span></paper-cell>
              <paper-cell class="dayHeader"><span>Hours</span></paper-cell>
            </paper-row>
            <template is="dom-repeat" items="[[userPtoData.vacUsed]]">
              <paper-row header short>
                <paper-cell class="dayHeader">
                  <span>[[item.key]]</span>
                </paper-cell>
                <paper-cell class="dayHeader">
                  <span>[[item.value]]</span>
                </paper-cell>
              </paper-row>
            </template>
            <template is="dom-if" if="[[!userPtoData.vacUsed.length]]">
              <paper-row header short>
                <paper-cell class="dayHeader">None</paper-cell>
              </paper-row>
            </template>
          </paper-table>
        </div>
      </katapult-dialog>

      <!-- Sick Leave Used Dialog -->
      <katapult-dialog id="sickLeaveUsedDialog" closeOnEscape closeOnOutsideClick closeButton maxwidth="600">
        <div slot="title">Paid Sick Leave</div>
        <div class="dialogBody" flex-column>
          <div>Sick Leave taken this year so far:</div>
          <paper-table class="payWeekTable" outline dividers rounded style="flex: 1;">
            <paper-row header short grey>
              <paper-cell class="dayHeader"><span>Date</span></paper-cell>
              <paper-cell class="dayHeader"><span>Hours</span></paper-cell>
            </paper-row>
            <template is="dom-repeat" items="[[userPtoData.sickTaken]]">
              <paper-row header short>
                <paper-cell class="dayHeader">
                  <span>[[item.key]]</span>
                </paper-cell>
                <paper-cell class="dayHeader">
                  <span>[[item.value]]</span>
                </paper-cell>
              </paper-row>
            </template>
            <template is="dom-if" if="[[!userPtoData.sickTaken.length]]">
              <paper-row header short>
                <paper-cell class="dayHeader">None</paper-cell>
              </paper-row>
            </template>
          </paper-table>
        </div>
      </katapult-dialog>

      <katapult-dialog id="usedFamilyCare" closeOnEscape closeOnOutsideClick closeButton maxwidth="600">
        <span slot="title">Family Care Leave</span>
        <div class="dialogBody" flex-column>
          <div>Family Care Time taken this year so far:</div>
          <paper-table class="payWeekTable" outline dividers rounded style="flex: 1;">
            <paper-row header short grey>
              <paper-cell class="dayHeader"><span>Date</span></paper-cell>
              <paper-cell class="dayHeader"><span>Hours</span></paper-cell>
            </paper-row>
            <template is="dom-repeat" items="[[userPtoData.famCareUsed]]">
              <paper-row header short>
                <paper-cell class="dayHeader">
                  <span>[[item.key]]</span>
                </paper-cell>
                <paper-cell class="dayHeader">
                  <span>[[item.value]]</span>
                </paper-cell>
              </paper-row>
            </template>
            <template is="dom-if" if="[[!userPtoData.famCareUsed.length]]">
              <paper-row header short>
                <paper-cell class="dayHeader">None</paper-cell>
              </paper-row>
            </template>
          </paper-table>
        </div>
      </katapult-dialog>
    `;
  }

  static get properties() {
    return {
      primaryControl: {
        type: Boolean,
        value: true
      },
      dividers: {
        type: Boolean,
        value: false
      },
      currentMonday: {
        type: Object,
        value: null,
        observer: 'setPreviousMonday'
      },
      weeklyTotals: {
        type: Array,
        computed: 'getWeeklyTotals(userTimesheets.*, currentMonday)',
        observer: 'updatePieChart'
      },
      weeklyGrandTotal: {
        type: Number,
        computed: 'getWeeklyGrandTotal(weeklyTotals.*)'
      },
      timesheetStatus: {
        type: Object,
        computed: 'getTimesheetStatus(currentMonday, userTimesheets.*)'
      },
      previousMonday: {
        type: Object,
        value: null
      },
      workWeekHours: {
        type: Number,
        value: 40
      },
      filteredOverheadTimeClasses: {
        type: Array,
        computed: 'getFilteredOverheadTimeClasses(overheadTimeClasses.*, timeClasses.*)'
      },
      hours: {
        type: Number,
        value: 0
      },
      overheadTimeClasses: {
        type: Array,
        value: []
      },
      selectedDate: {
        type: String,
        value: null
      },
      // TODO (12-15-2021): Remove eventually
      selectedUid: {
        type: String,
        value: null
      },
      timeClasses: {
        type: Array,
        computed: 'getTimeClasses(selectedDate, userTimeClasses, userTimesheets.*)'
      },
      tooltipIsInvisible: {
        type: Boolean,
        value: true
      },
      userIsTimesheetManager: {
        type: Boolean,
        value: false
      },
      userIsAdminLMA: {
        type: Boolean,
        value: false
      },
      // TODO (12-14-2021): Remove eventually
      usernames: {
        type: Array,
        value: []
      },
      userTimeTracking: {
        type: Array,
        value: []
      },
      payWeekData: {
        type: Array,
        computed: 'getPayWeekData(currentMonday, userTimesheets.*)'
      },
      timesheetMetadata: {
        type: Object,
        value: () => ({
          growthRating: 0
        })
      },
      validHours: {
        type: Boolean,
        value: true
      },
      userPtoData: {
        type: Object,
        value: {
          vacAllotted: null,
          vacUsed: null,
          vacUsedTotal: null,
          vacRemaining: null,
          sickTaken: null,
          sickTakenTotal: null,
          famCareAllotted: null,
          famCareUsed: null,
          famCareUsedTotal: null,
          famCareRemaining: null
        }
      },
      manualChange: {
        type: Boolean,
        value: false
      },
      timesheetOptions: {
        type: Object,
        value: () => {},
        observer: 'setWorkWeekHours'
      },
      enabledFeatures: {
        type: Object,
        value: () => ({})
      }
    };
  }

  static get observers() {
    return [
      'loadTimeClassesModels(user.uid, userGroup)',
      'updateIsTimesheetManager(user, userGroup)',
      'updateCompanyTeams(user, userGroup)',
      'updateUserTimesheetsListener(user.uid, userGroup, currentMonday)',
      'updatePtoListener(user.uid, userGroup, selectedUid)',
      'updatePtoTable(user.uid, userGroup, userPtoData, selectedUid)',
      'getTimesheetOptions(userGroup)'
    ];
  }

  static get importMeta() {
    return import.meta;
  }

  constructor() {
    super();

    // Default properties
    this.timesheetStatus = {
      submitted: false,
      appended: false,
      locked: false
    };
    this.payWeekData = [];
    this.weeklyTotals = [];
    this.userTimeClasses = [];
    this.timeClasses = [];
    this.user = null;
    this.userGroup = null;
    this.catalogData = null;
    /** @type {KatapultTimesheetRecord[]} */
    this.userTimesheets = [];
    this.timesheetMetadata = {};
    this.usernames = [];

    // Template helpers
    this.greaterThan = (a, b) => a > b;
    this.or = (a, b) => a || b;
  }

  /**
   * A reference to the FirebaseWorker database.
   * @type {firebase.database.Database}
   */
  get database() {
    return globalThis.FirebaseWorker.database();
  }

  /**
   * A reference to the Firestore database.
   * @type {firebase.firestore.Firestore}
   */
  get firestore() {
    return firebase.firestore();
  }

  /**
   * A time class allocation for a day.
   * @typedef {object} TimeAllocation
   * @property {string} date - The ISO date string for the day.
   * @property {number} hours - The number of hours allocated to the time class (allocation) for the day.
   * @property {string[]} labels - The labels for this allocation.
   * @property {string} note - A note for the allocation.
   * @property {boolean} part_time_secondary - Whether the allocation is for a part-time secondary role.
   * @property {string} tag - (LEGACY) The day-split tag for the allocation (should be `'default'`).
   * @property {string} time_class - The ID of the time class for the allocation.
   * @property {string} time_description - The description of the time class allocation.
   * @property {string} weekday - The weekday name for the day.
   */

  /**
   * The data for a timesheet record.
   * @typedef {object} KatapultTimesheetRecord
   * @property {boolean} appended - Whether the timesheet has been appended to.
   * @property {number} bonus - The bonus amount for the week.
   * @property {string} bonus_note - The note provided for the bonus.
   * @property {boolean} certified - (LEGACY) Whether the timesheet has been certified.
   * @property {string} general_note - The general note for the week.
   * @property {number} growth_rating - The growth rating for the week.
   * @property {TimeAllocation[]} hours - The hour allocations for the week.
   * @property {firebase.firestore.Timestamp} last_updated - The timestamp of the last update to the timesheet.
   * @property {boolean} legal_agreed - Whether the user has agreed to the legal terms.
   * @property {boolean} locked - Whether the timesheet is locked.
   * @property {boolean} submitted - Whether the timesheet has been submitted.
   * @property {firebase.firestore.Timestamp} submitted_timestamp - The timestamp of the submission.
   * @property {string} uid - The UID of the user.
   * @property {string} vision_note - (LEGACY) The vision note for the week.
   * @property {string} week_ending - The ISO date for the end of the week.
   * @property {string} week_starting - The ISO date for the start of the week.
   * @property {firebase.firestore.DocumentReference} [_ref] - The reference to the Firestore document.
   */

  connectedCallback() {
    super.connectedCallback();

    this.jobDashboardsFlagListener = addFlagListener('job_dashboards', (enabled) => {
      this.set('enabledFeatures.job_dashboards', enabled);
    });

    this.visibilitychangeHandler = () => {
      if (document.visibilityState == 'visible') {
        clearInterval(this.updateLivePropsInterval);
        this.updateLiveProps();
        this.updateLivePropsInterval = setInterval(this.updateLiveProps, 1000);
      } else clearInterval(this.updateLivePropsInterval);
    };

    // Add visibility handling
    document.addEventListener('visibilitychange', this.visibilitychangeHandler);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    removeFlagListener('job_dashboards', this.jobDashboardsFlagListener);

    // Remove visibility handling
    document.removeEventListener('visibilitychange', this.visibilitychangeHandler);
  }

  ready() {
    super.ready();
    // Initialize date properties to now
    this.updateDates();

    // Update live property values and continue to do so every second
    this.updateLiveProps();
    this.updateLivePropsInterval = setInterval(this.updateLiveProps, 1000);
  }

  updateDates() {
    this.selectedDate = DateTime.now();
    this.currentMonday = this.getMonday(this.selectedDate);
    this.setPreviousMonday();
  }

  setPreviousMonday() {
    this.previousMonday = this.currentMonday?.minus({ days: 7 });
  }

  setWorkWeekHours() {
    const workWeekHours = this.timesheetOptions?.regular_work_week_hours ?? 40;
    // Only set the work week hours from config one time
    if (workWeekHours && !this._setWorkWeekHoursFromConfig) {
      this.workWeekHours = workWeekHours;
      this._setWorkWeekHoursFromConfig = true;
    }
  }

  getWeekdayButtonClasses(weekday) {
    const isWeekend = ['Saturday', 'Sunday'].includes(weekday.weekday);
    const isSaved = weekday.hours?.default > 0;
    const { isSubmitted, isAppended, isLocked } = weekday;
    const classList = [
      'weekday-button',
      ...(isLocked ? ['weekday-button-locked'] : []),
      ...(isWeekend && isSaved ? ['weekday-button-saved-weekend'] : []),
      ...(isWeekend && isAppended ? ['weekday-button-submitted-weekend'] : []),
      ...(!isWeekend && isSaved ? ['weekday-button-saved'] : []),
      ...(!isWeekend && isSubmitted ? ['weekday-button-submitted'] : [])
    ];
    return classList.join(' ');
  }

  ifElse(x, a, b) {
    return x ? a : b;
  }

  async unlockAllottedVacationCalc(e) {
    this.manualChange = false; // Changes revert button visibility
    const uidOfUserToModify = this.selectedUid || this.user.uid;
    const vacAllotted = await this.calculateVacationAllotment(uidOfUserToModify, this.userGroup);

    await FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/user_data/${uidOfUserToModify}/pto/vacation/`).update({
      allotted: vacAllotted,
      manualChange: false
    });
  }

  async adminDataUpdate(e) {
    const type = e.currentTarget.dataset.type;
    const uidOfUserToModify = this.selectedUid || this.user.uid;
    const userPtoRef = FirebaseWorker.database().ref(
      `photoheight/company_space/${this.userGroup}/user_data/${uidOfUserToModify}/pto/${type}`
    );
    const userIsFulltime = this.userData?.employment?.fulltime_start_date != null;

    if (userIsFulltime) {
      this.manualChange = true;
      await userPtoRef.update({
        allotted: Number(type == 'vacation' ? this.adminVacAllotted : this.adminFamCareAllotted),
        manualChange: type == 'vacation' || null
      });
    } else console.warn('Not a full time employee');
  }

  addAllocation(e) {
    // If selected item is null, do nothing
    if (!e.detail.selectedItem) return;

    // Otherwise, cancel the action and use the value
    e.currentTarget.preventSelection = true;
    this.push('timeClasses', { ...e.detail.selectedItem, hours: 0, _hours: '0:00' });
  }

  // TODO (12-14-2021): Remove
  adminUpdateUid(e) {
    this.selectedUid = e.detail.value;
    if (this.selectedUid == this.user.uid) this.selectedUid = null;
    this.loadTimeClassesModels(e.detail.value || this.user.uid, this.userGroup);
    this.updateUserTimesheetsListener(e.detail.value || this.user.uid, this.userGroup, this.currentMonday, true);
  }

  async exportTimesheetData(e) {
    // Get the export type from the element
    const exportType = e.currentTarget.dataset.exportType;
    // Get the export filename from the element
    const exportFilename = e.currentTarget.dataset.exportFilename ?? exportType;

    // Generate the export
    const [output, warnings] = await this.#runAdminExport(exportType);
    this.exportWarnings = warnings;

    // Download
    Download(output, `${exportFilename}.csv`);
  }

  async #runAdminExport(exportType) {
    switch (exportType) {
      case 'kp': {
        const settings = {
          startDate: this.previousMonday,
          endDate: this.previousMonday.plus({ days: 6 }),
          workWeekHours: this.workWeekHours,
          exportAllTeams: true
        };
        return await AdminExports.teamData(this.userGroup, this.user.uid, settings);
      }
      case 'team-data': {
        const settings = {
          startDate: DateTime.fromISO(this.exportStartDate),
          endDate: DateTime.fromISO(this.exportEndDate),
          workWeekHours: this.workWeekHours,
          selectedTeam: this.selectedTeamForExport,
          exportAllTeams: this.exportAllTeams,
          exportAllTeamsLedByUser: this.exportAllTeamsLedByUser
        };
        return await AdminExports.teamData(this.userGroup, this.user.uid, settings);
      }
      case 'survey':
        return await AdminExports.endOfWeekSurvey(this.userGroup, this.currentMonday);
      case 'payroll-1':
        return await AdminExports.payroll(
          this.userGroup,
          this.currentMonday,
          this.currentMonday.plus({ days: 6 }),
          this.currentMonday,
          this.currentMonday.plus({ days: 6 })
        );
      case 'payroll-2':
        return await AdminExports.payroll(
          this.userGroup,
          this.currentMonday,
          this.currentMonday.plus({ days: 13 }),
          this.currentMonday,
          this.currentMonday.plus({ days: 13 })
        );
      case 'payroll-range': {
        let start = DateTime.fromISO(this.exportStartDate);
        let end = DateTime.fromISO(this.exportEndDate);
        return await AdminExports.payroll(this.userGroup, start, end, this.getMonday(start), this.getMonday(end));
      }
      case 'unpaid-leave': {
        let start = DateTime.fromISO(this.exportStartDate);
        let end = DateTime.fromISO(this.exportEndDate);
        return await AdminExports.unpaidLeave(this.userGroup, this.getMonday(start), this.getMonday(end));
      }
    }
    throw new Error('Invalid export type');
  }

  /**
   * Get the timesheet for the given date.
   * @param {DateTime} date - The date to find the associated timesheet for
   * @returns {KatapultTimesheetRecord|null}
   */
  findTimesheet(date) {
    const isoDate = /** @type {string} */ ((date || DateTime.now()).toISODate());
    // Return the associated timesheet for the given data
    return this.userTimesheets?.find((x) => x.week_starting <= isoDate && x.week_ending >= isoDate) ?? null;
  }

  getWeeklyGrandTotal() {
    return this.weeklyTotals?.reduce((acc, x) => (acc += x.hours), 0) ?? 0;
  }

  getWeeklyTotals() {
    // Short circuit if we are missing either of the required props
    if (!this.currentMonday || !this.userTimesheets?.length) return [];
    // Otherwise, get starting values
    const weeklyTotals = [];
    const hours = this.findTimesheet(this.currentMonday)?.hours || [];

    // Filter hours to the katapult cycle
    const weekTotalHours = hours.reduce((acc, x) => (acc += x.hours), 0);

    // If this week has 0 hours, skip
    if (weekTotalHours == 0) return [];
    // For each time class doc
    for (const timeClass of hours) {
      // For each allocation, add its hour data to the cycle
      let index = weeklyTotals.findIndex((a) => (a.description || a.class) == (timeClass.time_description || timeClass.time_class));
      if (index >= 0) weeklyTotals[index].hours += timeClass.hours;
      else
        weeklyTotals.push({
          class: timeClass.time_class,
          description: timeClass.time_description,
          hours: timeClass.hours,
          color: randomColor({ seed: timeClass.time_class, format: 'rgb', luminosity: 'light' })
        });
    }

    // Filter out rows with 0 hours and, for each row, calc the % share of the entire week and string hours
    return weeklyTotals
      .filter((total) => total.hours > 0)
      .map((row) =>
        Object.assign(row, {
          share: Math.round((row.hours / weekTotalHours) * 100).toString() + '%',
          _hours: this.toTimeString(row.hours)
        })
      );
  }

  getTimesheetStatus() {
    const timesheet = this.findTimesheet(this.currentMonday);
    return {
      submitted: !!timesheet?.submitted,
      appended: !!timesheet?.appended,
      locked: !!timesheet?.locked
    };
  }

  getDateRangeString(weekStartDate, format = 'DATE_MED', length = 6) {
    if (!weekStartDate) return;
    // Get the end date by adding length (6 by default) to the start date
    let weekEndDate = weekStartDate.plus({ days: length });
    // Get the formatting object
    return `${weekStartDate.toLocaleString(DateTime[format])} - ${weekEndDate.toLocaleString(DateTime[format])}`;
  }

  getFilteredOverheadTimeClasses() {
    let existingTimeClassesNames = this.timeClasses?.map((x) => x.name) || [];
    return this.overheadTimeClasses?.filter((x) => !existingTimeClassesNames.includes(x.name)) || [];
  }

  getMonday(date) {
    // Get a new date object from the passed date, and set the weekday to Monday (1)
    let monday = date.set({ weekday: 1 });
    // If the monday is beyond the current date, the week start should be a week sooner
    if (monday.weekday > date.weekday) monday = monday.plus({ days: -7 });
    // Return the date object
    return monday;
  }

  getPayCycleData(timesheet) {
    const hours = timesheet?.hours || [];

    // Legacy overhead time classes that no longer exist in the database, but should be included for viewing historical timesheet data
    const LEGACY_OVERHEAD_TIME_CLASSES = ['Performance-Based PTO'];
    // Get all overhead time classes
    const overheadTimeClassNames = [...this.overheadTimeClasses.map((x) => x.name), ...LEGACY_OVERHEAD_TIME_CLASSES];

    // For each of a counted range, add to monday and get that day's data
    return this.getWeekdays(this.currentMonday, 7, 'short').map((day) => {
      const todaysHours = hours.filter((x) => x.date == day.date.toISODate());
      const workedHours = todaysHours.filter((x) => !overheadTimeClassNames.includes(x.time_class) && !x.part_time_secondary);
      const overheadHours = todaysHours.filter((x) => overheadTimeClassNames.includes(x.time_class) && !x.part_time_secondary);
      const partTimeSecondaryHours = todaysHours.filter((x) => x.part_time_secondary);
      return {
        date: day.date.toLocaleString(DateTime.DATE_SHORT),
        weekday: day.weekday,
        hoursWorked: workedHours.reduce((acc, x) => (acc += x.hours), 0) || 0,
        paidTimeOff: overheadHours.reduce((acc, x) => (acc += x.hours), 0) || 0,
        partTimeSecondary: partTimeSecondaryHours.reduce((acc, x) => (acc += x.hours), 0) || 0
      };
    });
  }

  getTimeClasses() {
    // If any arguments of this update function are undefined, short-circuit
    if (!this.selectedDate || !this.userTimeClasses) return;

    // Get all configured time classes available for the selected date
    const startOfSelectedDate = this.selectedDate.startOf('day');
    const timeClassesForSelectedDate = this.userTimeClasses
      .filter((x) => (x.start_date || 0) <= startOfSelectedDate && (x.end_date || Infinity) >= startOfSelectedDate)
      .map((x) => ({ ...x, hours: 0 }));

    // Get existing time allocations
    const timesheet = this.findTimesheet(this.selectedDate);
    const hours = timesheet?.hours.filter((x) => x.date == this.selectedDate.toISODate());

    if (Array.isArray(hours)) {
      for (const record of hours) {
        // Search for the index of a class with the same name as the current record
        const index = timeClassesForSelectedDate.findIndex(
          (x) => (x.description || x.class) == (record.time_description || record.time_class)
        );
        // If one exists, add the data to it
        if (index >= 0) timeClassesForSelectedDate[index] = { ...timeClassesForSelectedDate[index], ...record };
        // If it doesn't, create it
        else timeClassesForSelectedDate.push({ ...record, name: record.time_class, description: record.time_description });
      }
    }

    // Add the hour string to each record
    for (const timeClass of timeClassesForSelectedDate) timeClass._hours = this.toTimeString(timeClass.hours || 0);

    // Sort the classes and set the property
    return timeClassesForSelectedDate.sort((a, b) => b.show_by_default - a.show_by_default);
  }

  getPayWeekData() {
    if (!this.currentMonday) return;
    const timesheet = this.findTimesheet(this.currentMonday);

    // For each of a counted range (0 to 7) add that number to week start and get data for the day
    return this.getWeekdays(this.currentMonday, 7).map((day) => {
      const weekdayISODate = day.date.toISODate();
      // Get the time allocations for the day
      const weekdayTimeAllocations = timesheet?.hours.filter((x) => x.date == weekdayISODate) || [];
      // Since June 2024, we no longer care about specific tags: we just want to sum all hours
      const hourTotalsByTag = { default: weekdayTimeAllocations.reduce((acc, x) => (acc += x.hours), 0) };

      return {
        date: day.date,
        label: day.date.toFormat('MM/dd'),
        weekday: day.weekday,
        hours: hourTotalsByTag,
        tag: 'default',
        isSubmitted: timesheet?.submitted,
        isAppended: timesheet?.appended,
        isLocked: timesheet?.locked
      };
    });
  }

  getWeekdays(startDate, count, weekday = 'long') {
    // Generate an array of date objects
    return Array.from(Array(count).keys()).map((val) => {
      let date = startDate.plus({ days: val });
      return { date, weekday: date.toLocaleString({ weekday: weekday }) };
    });
  }

  // There's probably a way to combine the signal functions into one, but I'm too brain dead to figure that out rn
  signalMainWeekStyle() {
    let reviewDialog = this.shadowRoot.querySelector('#reviewSubmitTimesheet');
    reviewDialog.classList.add('mainWeek');
  }

  signalAddendumWeekStyle() {
    let reviewDialog = this.shadowRoot.querySelector('#reviewSubmitTimesheet');
    reviewDialog.Dialog.classList.remove('mainWeek');
  }

  hideTooltip() {
    this.tooltipIsInvisible = true;
  }

  jumpToToday() {
    // Get some helpful reference dates
    const today = DateTime.fromISO(this.liveIsoDate);
    // If this is a pay week, simply set to monday
    this.currentMonday = this.getMonday(today);
  }

  async loadNames() {
    if (this.usernames.length > 0) return;
    // Get usernames from firebase
    this.allUsersData = (await this.database.ref(`users/${this.userGroup}`).once('value')).val();
    const userEntriesWithEmails = Object.entries(this.allUsersData ?? {}).filter(([, { email }]) => !!email);
    this.usernames = userEntriesWithEmails.map(([uid, { email }]) => ({ email, uid }));
  }

  async loadTimeClassesModels(uid, userGroup) {
    // Short circuit if we are missing either of the required props
    if (uid == null || userGroup == null) return;

    // Otherwise, get classes from firebase
    const userTimeClasses = [];
    const companyRef = this.database.ref(`photoheight/company_space/${userGroup}`);
    const projects = (await companyRef.child(`project_tracking/projects`).once('value')).val();

    for (const project of Object.values(projects ?? {})) {
      const userItems = project.users?.filter((x) => project.type != 'recurring' && (x.uid == uid || x.uid == '_all')) ?? [];
      userItems.forEach((userItem) => {
        userTimeClasses.push({
          name: project.name,
          labels: project.labels,
          part_time_secondary: userItem.part_time_secondary,
          description: userItem.description,
          start_date: userItem.start_date ? DateTime.fromISO(userItem.start_date) : null,
          end_date: userItem.end_date ? DateTime.fromISO(userItem.end_date) : null,
          archived: project.archived
        });
      });
    }
    this.userTimeClasses = userTimeClasses;

    // Get user data
    this.userData = (await this.database.ref(`users/${userGroup}/${uid}`).once('value')).val();
    // If the user is a full-time employee, get overhead time classes
    if (this.userData?.employment?.employment_type == 'regular') {
      this.overheadTimeClasses = (await companyRef.child(`models/overhead_time_allocations`).once('value')).val();
      this.fullTimeEmployee = true;
    }
  }

  updatePtoListener(uid, userGroup) {
    if (typeof this.unsubscribePtoListener == 'function') {
      this.unsubscribePtoListener();
    }
    if (uid == null || userGroup == null) {
      return;
    }

    let ptoReference = null;

    if (this.selectedUid == null) {
      ptoReference = FirebaseWorker.ref(`photoheight/company_space/${userGroup}/user_data/${uid}/pto`);
    } else {
      ptoReference = FirebaseWorker.ref(`photoheight/company_space/${userGroup}/user_data/${this.selectedUid}/pto`);
    }

    let listenerCallback = ptoReference.on('value', (s) => {
      this.userPtoData = this.calculatePtoData(s.val());
    });
    this.unsubscribePtoListener = () => ptoReference.off('value', listenerCallback);
  }

  calculatePtoData(data) {
    let vacUsedTotal = 0;
    let vacUReformatted = [];
    const vacAllotted = data.vacation.allotted || 0;
    const vacUsed = data.vacation.used;
    const currentYear = new Date().getFullYear();

    for (const [key, value] of Object.entries(vacUsed ?? {})) {
      // Make sure to only add the values that are from the current year in cases where the week includes days from the previous year or the next year
      const entryYear = Number(key.slice(0, 4));
      if (entryYear != currentYear) continue;

      vacUsedTotal += Number(`${value}`);
      if (Number(value) != 0) {
        // Table only displays dates with nonzero values (database still keeps them in case the changes need to be referenced)
        vacUReformatted.push({ key: String(key), value: Number(value) });
      }
    }

    let sickTakenTotal = 0;
    let sickTakenReformatted = [];
    const sickTaken = data.sick;
    for (const [key, value] of Object.entries(sickTaken ?? {})) {
      sickTakenTotal += Number(`${value}`);
      if (Number(value) != 0) {
        sickTakenReformatted.push({ key: String(key), value: Number(value) });
      }
    }

    let famCareUsedTotal = 0;
    let famCareUReformatted = [];

    let famCareAllotted = vacAllotted === 0 ? 0 : data?.fcl?.allotted;

    const famCareUsed = data?.fcl?.used || 0;
    for (const [key, value] of Object.entries(famCareUsed ?? {})) {
      famCareUsedTotal += Number(`${value}`);
      if (Number(value) != 0) {
        famCareUReformatted.push({ key: String(key), value: Number(value) });
      }
    }

    return {
      vacAllotted: vacAllotted,
      vacUsed: vacUReformatted,
      vacUsedTotal: vacUsedTotal,
      vacRemaining: vacAllotted - vacUsedTotal,
      sickTaken: sickTakenReformatted,
      sickTakenTotal: sickTakenTotal,
      famCareAllotted: famCareAllotted,
      famCareUsed: famCareUReformatted,
      famCareUsedTotal: famCareUsedTotal,
      famCareRemaining: famCareAllotted - famCareUsedTotal
    };
  }

  async updatePtoTable(uid, userGroup) {
    // Get user data
    if (this.selectedUid == null) {
      this.userData = await FirebaseWorker.ref(`users/${userGroup}/${uid}`)
        .once('value')
        .then((s) => s.val());
    } else {
      this.userData = await FirebaseWorker.ref(`users/${userGroup}/${this.selectedUid}`)
        .once('value')
        .then((s) => s.val());
    }

    try {
      // Check to see if admin has changed the vacation allotted value
      const uidOfUserToModify = this.selectedUid || uid;
      const userVacationRef = FirebaseWorker.database().ref(
        `photoheight/company_space/${userGroup}/user_data/${uidOfUserToModify}/pto/vacation`
      );
      const manualChangeSnapshot = await userVacationRef.child(`manualChange`).once('value');
      this.manualChange = manualChangeSnapshot.val();

      // Only allow writes if not manually changed
      if (!this.manualChange) {
        const vacAllotted = await this.calculateVacationAllotment(uid, userGroup);
        userVacationRef.update({ allotted: vacAllotted }); // Write calculated allotted time
      }
    } catch (error) {
      console.error(error);
      console.log('Uid is not a fulltime employee');
      return;
    }
  }

  async calculateVacationAllotment(uid, userGroup) {
    const oneYear = 31556952000;
    const fourteenDayPay = 1209600000;

    const startTime =
      this.selectedUid == null
        ? await FirebaseWorker.ref(`/users/${userGroup}/${uid}/employment/fulltime_start_date`)
            .once('value')
            .then((s) => s.val()) // Reads currently logged in employee start time
        : await FirebaseWorker.ref(`/users/${userGroup}/${this.selectedUid}/employment/fulltime_start_date`)
            .once('value')
            .then((s) => s.val()); // Reads selected employee start time

    let vacAllotted = 0;
    let startDate = new Date(startTime);
    let startYear = startDate.getYear();
    let currentYear = new Date(new Date().getTime());
    currentYear = currentYear.getYear();
    // Calculate new allotted vacation time
    let elapsedFullTime = new Date().getTime() - startTime; // Fulltime employment elapsed, in epoch
    let anniversaryYearFive = currentYear == startYear + 5;
    let anniversaryYearTen = currentYear == startYear + 10;

    if (elapsedFullTime / oneYear < 5) {
      // First year, "new anniversary"

      if (startYear == currentYear) {
        vacAllotted = Math.ceil(
          ((oneYear /*Milsecs in year */ - (startTime % oneYear)) /* Gets how far through the year the anniversary is*/ /
            fourteenDayPay) /*14 day pay period*/ *
            3.08
        );
      } else {
        vacAllotted = 80;
      }
    } else if (elapsedFullTime / oneYear >= 5 && elapsedFullTime / oneYear < 10) {
      //10 years > Elapsed full time >= 5 years

      if (anniversaryYearFive == true) {
        vacAllotted = 80 + Math.ceil(((oneYear - (startTime % oneYear)) / fourteenDayPay) * 3.08);
      } else {
        vacAllotted = 120;
      }
    } else if (elapsedFullTime / oneYear >= 10) {
      // Elapsed full time >= 10 years

      if (anniversaryYearTen == true) {
        vacAllotted = 120 + Math.ceil(((oneYear - (startTime % oneYear)) / fourteenDayPay) * 3.08);
      } else {
        vacAllotted = 160;
      }
    }

    // This is a flag to catch anyone who has a fulltime_start_date of 0
    if (startYear == 69) {
      vacAllotted = 0;
    }
    return Number(vacAllotted);
  }

  async lockThisWeek() {
    // Update every firestore record with the same week start date
    let timesheets = await this.timeTrackingCollection.where('week_starting', '==', this.currentMonday.toISODate()).get();
    timesheets.docs?.forEach((doc) => doc.ref.update({ locked: true }));
  }

  maybeUpdateHours(e) {
    if (e.key == 'Enter') this.updateHours(e);
  }

  promptTimeEntryDialog(e) {
    // Update selected date and date descriptor to the button pressed
    this.selectedDate = e.model.item.date;
    this.timeEntryDialogTitle = this.selectedDate.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY);

    const selectedISODate = this.selectedDate.toISODate();
    // Determine which timesheet to look on
    const timesheet = this.findTimesheet(this.selectedDate);
    this.totalHours = timesheet
      ? // If the timesheet exists, filter the hours to the selected date and sum them
        timesheet.hours?.filter((x) => x.date == selectedISODate).reduce((acc, x) => (acc += x.hours), 0)
      : // If no timesheet fits the description, return 0
        0;

    // Open the dialog
    /** @type {KatapultDialog|null} */
    const dialog = this.shadowRoot?.querySelector('#timeEntryDialog') ?? null;
    if (!dialog) throw new Error('Dialog not found');
    dialog.open();
  }

  promptVacationAllottedDialog(e) {
    const bodyText = `Paid vacation time is offered on a yearly basis to all benefits-eligible employees as follows:

    • Upon hire - 80 hours per year (prorated for the first year based on start date)
    • After 5 years - 120 hours per year (prorated during anniversary year based on anniversary date)
    • After 10 years - 160 hours per year (prorated during anniversary year based on anniversary date)

    All vacation time needs to be requested and approved by your supervisor in writing. A simple "I'm planning to take vacation time on such and such dates. Let me know if that does not work." will do. Whenever possible, please give notice in the amount of 4 times the amount of time you will be taking off. Vacation is considered "use it or lose it" and does not carry over into the next calendar year. We encourage you to enjoy life during your time at Katapult and take much-deserved rest, rather than hoard up vacation hours over multiple years.

    Please update the Not Working Calendar and your personal calendar with your Vacation Time!`;
    KatapultDialog.alert({
      body: bodyText,
      dialog: { title: 'Vacation', color: 'var(--secondary-color)', closeButton: true }
    });
  }

  promptVacationUsedDialog() {
    this.shadowRoot.querySelector('#vacationUsedDialog').open();
  }

  promptVacationRemainingDialog() {
    KatapultDialog.alert({
      body: `Vacation days do not carry over between years; be sure to take time to rest.`,
      dialog: { title: 'Vacation', color: 'var(--secondary-color)', closeButton: true }
    });
  }

  promptSickLeaveDialog() {
    KatapultDialog.alert({
      body: `Katapult provides paid sick time as needed for benefits-eligible employees instead of applying a specific limit. Katapult believes this represents fair exchange because it allows you to work when you are healthy and to fully rest and recover when you're sick, without having to worry about missing a paycheck.

      If you have any type of contagious sickness, illness-related vomiting, fever, or diarrhea, we ask that you stay home and not return to the office until 24 hours after the symptoms have subsided. While you are home, you are able to work remotely; but if you are not feeling up to it, please rest and take this time to recover. In addition, if you have any type of serious injury, mental health emergency, extreme discomfort, or any other type of situation that prevents you from working, we encourage you to stay home and seek the proper treatment.
      
      Sick leave is not intended to be used to care for sick family members. We realize that sick family members do put an additional burden on employees so we encourage employees to work remotely or use family care leave, flex time, and vacation time (if needed) to meet the needs of this demand.
      
      Paid sick leave may be used, in accordance with work time missed due to illness, to bring your total hours for the week up to a maximum of 40 hours. If you are sick for several days, we encourage you to seek professional care and reach out to your supervisor so you can work together and plan accordingly. Our current record for consecutive sick days is seven days. We are hoping for your sake and ours that you don't beat it!
      
      All sick time must be placed on the Not Working calendar and a notification e-mail must be sent to your supervisor.`,
      dialog: { title: 'Paid Sick Leave', color: 'var(--secondary-color)', closeButton: true }
    });
  }

  promptSickLeaveUsedDialog() {
    this.shadowRoot.querySelector('#sickLeaveUsedDialog').open();
  }

  promptAllottedFamilyCareDialog() {
    KatapultDialog.alert({
      body: `Katapult recognizes the importance of supporting our employees in maintaining a healthy work-life balance and providing care for their families. Benefits-eligible employees can use up to 3 days (24 hours) of family care leave per calendar year to attend to their family care responsibilities without having to worry about decreasing their take-home pay.

      Family care leave is designed to be used for the care of a child, spouse, or parent with a sickness, injury, or medical condition requiring significant assistance or support. While flex time and working remotely can often be used to meet your family member's needs, we recognize that at times the type of assistance or support needed does not allow for those two options to suffice. Staff should typically use flex time to cover a scheduled medical appointment that is 1-2 hours. Family care time will typically be used to cover a half-day or greater need for support.
      
      Family care leave may be used, in accordance with work time missed due to caring for family members, to bring your total hours for the week up to a maximum of 40 hours.
      
      All family care time must be placed on the Not Working calendar and you need to notify your supervisor as soon as possible. Please work with your supervisor and team to ensure adequate coverage during your absence.`,
      dialog: { title: 'Family Care Leave', color: 'var(--secondary-color)', closeButton: true }
    });
  }

  promptUsedFamilyCareDialog() {
    this.shadowRoot.querySelector('#usedFamilyCare').open();
  }

  promptRemainingFamilyCareDialog() {
    this.shadowRoot.querySelector('#remainingFamilyCare').open();
  }

  promptExportDialog(e) {
    this.shadowRoot.querySelector('#exportDialog').open();
  }

  promptExportDialogLMA(e) {
    this.resetExportDateRange();
    if (this.teamsUserIsLeaderOf.length == 1) this.selectedTeamForExport = this.teamsUserIsLeaderOf.at(0)[0];
    this.shadowRoot.querySelector('#exportDialogLMA').open();
  }

  promptReviewSubmitTimesheet() {
    const timesheet = this.findTimesheet(this.currentMonday);
    // Get the pay cycle breakdown and totals from it
    this.payCycleBreakdown = this.getPayCycleData(timesheet);

    // Get company and user info
    const workWeekLength = this.timesheetOptions?.regular_work_week_hours ?? 40;
    const userIsSalaried = this.userData.employment?.salaried ?? false;

    // Get total hours for worked, paid time off, and part-time secondary
    const hoursWorked = this.payCycleBreakdown.reduce((total, day) => (total += day.hoursWorked), 0);
    const paidTimeOff = this.payCycleBreakdown.reduce((total, day) => (total += day.paidTimeOff), 0);
    const partTimeSecondary = this.payCycleBreakdown.reduce((total, day) => (total += day.partTimeSecondary), 0);

    // Calculate and set pay cycle totals object
    this.payCycleTotals = {
      hoursWorked: hoursWorked,
      regular: !userIsSalaried && hoursWorked > workWeekLength ? workWeekLength : hoursWorked,
      overtime: userIsSalaried || hoursWorked < workWeekLength ? 0 : hoursWorked - workWeekLength,
      paidTimeOff,
      partTimeSecondary,
      grandTotal: this.timesheetOptions?.allow_pto_reporting
        ? hoursWorked + paidTimeOff + partTimeSecondary
        : hoursWorked + partTimeSecondary
    };

    // Get the weekly bonus from the timesheet
    this.timesheetMetadata = {
      bonus: timesheet?.bonus ?? '',
      bonusNote: timesheet?.bonus_note ?? '',
      visionNote: timesheet?.vision_note ?? '',
      growthRating: timesheet?.growth_rating ?? 0,
      generalNote: timesheet?.general_note ?? '',
      legalAgreed: timesheet?.legal_agreed ?? false
    };
    this.styleGrowthRatingIcons();

    // Set the title of the dialog based on the state of the timesheet
    this.reviewDialogTitle = !timesheet?.submitted
      ? 'Review and Submit Timesheet'
      : !timesheet?.locked
        ? 'Append to Timesheet'
        : 'Review Timesheet (Read-Only)';

    // Load the text from the timesheetOptions
    this.setTimesheetSubmissionTextEntries();

    // Open the dialog
    /** @type {KatapultDialog|null} */
    const dialog = this.shadowRoot?.querySelector('#reviewSubmitTimesheet') ?? null;
    dialog?.open();
  }

  selectAllText(e) {
    e.currentTarget.shadowRoot.querySelector('input').select();
  }

  setProperty(e) {
    // Get the path from the element's dataset and replace the index template
    let path = e.currentTarget.dataset.path;
    path = path.replace('$index', e.model?.index);
    // Update the property
    this.set(path, e.detail.value);
  }

  async ptoUpdate(fclHours, sickHours, vacationHours, date, uid, userGroup, famCareRemaining, vacRemaining, tag) {
    if (fclHours != null) {
      // Check to see if the user actually used this field (id="input-27")
      let existingForDate = await FirebaseWorker.ref(`photoheight/company_space/${userGroup}/user_data/${uid}/pto/fcl/used/${date}/`)
        .once('value')
        .then((s) => s.val());
      if (tag != 'default' && tag != null) {
        FirebaseWorker.ref(`photoheight/company_space/${userGroup}/user_data/${uid}/pto/fcl/used/`).update({
          [date + ' ' + tag]: fclHours
        });
      } else {
        FirebaseWorker.ref(`photoheight/company_space/${userGroup}/user_data/${uid}/pto/fcl/used/`).update({ [date]: fclHours });
      }
      if (fclHours !== 0 && fclHours > famCareRemaining) {
        // Something like the original if/else structure will need to be reinstated whenever the timesheet submission block is implemented
        KatapultDialog.alert({
          body: `The Family Care Leave time entered exceeds benefit time allotted.\nPlease revise this if this was unintended.`,
          dialog: { title: 'Family Care Leave Time Exceeded', color: 'var(--paper-red-500)', closeButton: true }
        });
      }
    }
    if (sickHours != null) {
      // Check to see if the user actually used this field (id="input-23")
      if (tag != 'default' && tag != null) {
        FirebaseWorker.ref(`photoheight/company_space/${userGroup}/user_data/${uid}/pto/sick`).update({ [date + ' ' + tag]: sickHours });
      } else {
        FirebaseWorker.ref(`photoheight/company_space/${userGroup}/user_data/${uid}/pto/sick`).update({ [date]: sickHours });
      }
    }
    if (vacationHours != null) {
      // Check to see if the user actually used this field (id="input-21")
      let existingForDate = await FirebaseWorker.ref(`photoheight/company_space/${userGroup}/user_data/${uid}/pto/vacation/used/${date}/`)
        .once('value')
        .then((s) => s.val());
      if (tag != 'default' && tag != null) {
        FirebaseWorker.ref(`photoheight/company_space/${userGroup}/user_data/${uid}/pto/vacation/used/`).update({
          [date + ' ' + tag]: vacationHours
        });
      } else {
        FirebaseWorker.ref(`photoheight/company_space/${userGroup}/user_data/${uid}/pto/vacation/used/`).update({ [date]: vacationHours });
      }
      if (vacationHours !== 0 && vacationHours > vacRemaining) {
        KatapultDialog.alert({
          body: `The Vacation time entered exceeds benefit time allotted.\nPlease revise this if this was unintended.`,
          dialog: { title: 'Vacation Time Exceeded', color: 'var(--paper-red-500)', closeButton: true }
        });
      }
    }
  }

  saveDay() {
    // Do not save if the user is not logged in
    if (!this.user?.uid) return;

    // Get the iso date string from the selected date
    const selectedISODate = this.selectedDate.toISODate();
    // Get the time classes that have data (hours or note)
    const weekday = this.selectedDate.toLocaleString({ weekday: 'long' });

    // Select the appropriate time sheet
    const timesheet = this.findTimesheet(this.selectedDate);

    const filteredTimeClasses = this.timeClasses.filter((x) => {
      const hasNonZeroHours = !!x.hours;
      const hasNote = !!x.note;
      // This checks if we're trying to change an already saved time class to 0 hours
      const hoursWasSetToZero = x.hours == 0 && timesheet?.hours.find((y) => y.time_class == x.name && y.date == selectedISODate);
      return hasNonZeroHours || hasNote || hoursWasSetToZero;
    });
    const todaysUpdateHours = filteredTimeClasses.map((x) => ({
      date: selectedISODate,
      weekday: weekday,
      time_class: x.name,
      time_description: x.description || '',
      labels: x.labels || [],
      hours: parseFloat(x.hours),
      note: x.note || '',
      tag: 'default',
      part_time_secondary: !!x.part_time_secondary
    }));

    // Validate the hours
    this.validHours = !todaysUpdateHours.some((x) => x.hours % 0.25 != 0 && this.totalHours > 0);
    if (!this.validHours) return;

    // Get the hours array and filter for hours from other days or other tags
    const hoursFromOtherDays = timesheet?.hours.filter((x) => x.date != selectedISODate) || [];

    // Build a new hours array with today's hours and the hours from the rest of the week
    const timesheetHours = [...todaysUpdateHours, ...hoursFromOtherDays].sort((a, b) => b.date - a.date);

    // If timesheet exists, update it using the ref
    if (timesheet) {
      timesheet._ref?.update({
        hours: timesheetHours,
        last_updated: serverTimestamp()
      });
    }
    // Otherwise, create a new timesheet document
    else {
      let weekStarting = this.getMonday(this.selectedDate);
      this.timeTrackingCollection.add({
        uid: this.user.uid,
        last_updated: serverTimestamp(),
        submitted: false,
        locked: false,
        week_starting: weekStarting.toISODate(),
        week_ending: weekStarting.plus({ days: 6 }).toISODate(),
        hours: timesheetHours,
        bonus: 0,
        bonus_note: '',
        certified: false
      });
    }

    // Close the dialog
    /** @type {KatapultDialog|null} */
    const dialog = this.shadowRoot?.querySelector('#timeEntryDialog') ?? null;
    dialog?.close();

    const fclHours = todaysUpdateHours.find((x) => x.time_class == 'Family Care Leave')?.hours ?? 0;
    const sickHours = todaysUpdateHours.find((x) => x.time_class == 'Sick')?.hours ?? 0;
    const vacationHours = todaysUpdateHours.find((x) => x.time_class == 'Vacation')?.hours ?? 0;

    this.ptoUpdate(
      fclHours,
      sickHours,
      vacationHours,
      selectedISODate,
      this.user.uid,
      this.userGroup,
      this.userPtoData?.famCareRemaining,
      this.userPtoData?.vacRemaining,
      'default'
    );

    if (this.enabledFeatures?.job_dashboards) {
      firebase.functions().httpsCallable('updateTimesheetDashboards')({ week_starting: this.currentMonday.toISODate() });
    }
  }

  shouldHideJumpButton(week) {
    return week.find((x) => x.date.toISODate() == this.liveIsoDate);
  }

  shouldHighlight(day) {
    // True if the passed day object is today
    return day.date.toISODate() == this.liveIsoDate;
  }

  async submitTimesheet(e) {
    const { submissionType } = e.currentTarget.dataset;

    // If the submission type is full, we actually want to submit the timesheet
    if (submissionType == 'full') {
      this.sliderIsInvalid = (this.timesheetMetadata?.growthRating ?? 0) == 0;
      const noteIsBlank = (this.timesheetMetadata?.generalNote ?? '').trim() === '';
      const legalNotAgreed = !this.timesheetMetadata?.legalAgreed;
      const submissionForm = /** @type {import('@polymer/iron-form').IronFormElement} */ (
        this.shadowRoot?.querySelector('#timesheetSubmissionForm')
      );
      const submissionFormInvalid = !submissionForm?.validate();

      // If the timesheet form fails validation (or has whitespace for a note), don't submit the timesheet
      if (submissionFormInvalid || this.sliderIsInvalid || legalNotAgreed || noteIsBlank) {
        if (this.sliderIsInvalid) {
          const labelForEmotions = this.shadowRoot?.querySelector('#labelEmotions');
          if (labelForEmotions) labelForEmotions.className = 'missing';
        }

        // Do not submit the timesheet
        return;
      }
    }

    // If we made it this far, the slider is not invalid (it truly is valid or we don't care)
    this.sliderIsInvalid = false;

    // Select the appropriate time sheet
    const timesheet = this.findTimesheet(this.currentMonday);

    // Once a timesheet is submitted, it cannot be "un-submitted" (it will be submitted on the first "full" submission)
    const shouldSubmit = timesheet?.submitted || submissionType === 'full';

    // Update the timesheet
    await timesheet?._ref?.update({
      // Submission data
      appended: timesheet?.appended || (timesheet?.submitted && submissionType === 'full'),
      submitted: shouldSubmit,
      submitted_timestamp: shouldSubmit ? serverTimestamp() : null,
      legal_agreed: shouldSubmit ? this.timesheetMetadata?.legalAgreed : false,
      // Bonus data
      bonus: this.timesheetMetadata?.bonus ?? '',
      bonus_note: this.timesheetMetadata?.bonusNote ?? '',
      // Other general data
      vision_note: this.timesheetMetadata?.visionNote ?? null,
      growth_rating: this.timesheetMetadata?.growthRating ?? 0,
      general_note: this.timesheetMetadata?.generalNote ?? null,
      last_updated: serverTimestamp(),
      certified: timesheet?.certified || shouldSubmit
    });

    if (this.enabledFeatures?.job_dashboards) {
      firebase.functions().httpsCallable('updateTimesheetDashboards')({ week_starting: this.currentMonday.toISODate() });
    }

    // Close the dialog
    /** @type {KatapultDialog|null} */
    (this.shadowRoot?.querySelector('#reviewSubmitTimesheet'))?.close();
    if (submissionType == 'full') Fireworks();
  }

  toggleLockTimesheet(e) {
    let timesheet = this.findTimesheet(this.currentMonday);
    timesheet?._ref?.update({ locked: !timesheet.locked });
  }

  toPercent(a, b) {
    if (!b) return '0%';
    return Math.round((a / b) * 100) + '%';
  }

  toTimeString(hours) {
    return Duration.fromObject({ hours }).toFormat('h:mm');
  }

  updateHours(e) {
    // Get data from the event
    let path = e.currentTarget.dataset.path;
    let value = e.currentTarget.value || '';
    // Replace the template value $index in the path (if necessary)
    path = path.replace('$index', e.model?.index);

    let formattedHours, dataHours;
    // If _hours contains a colon
    if (value.includes(':')) {
      let hours = value.split(':')[0] || 0;
      let minutes = value.split(':')[1] || 0;
      // Normalize input
      formattedHours = Duration.fromObject({ hours: hours, minutes: minutes }).toFormat('h:mm');
      dataHours = parseFloat(hours) + parseFloat(minutes) / 60;
    } else {
      formattedHours = this.toTimeString(parseFloat(value || 0));
      dataHours = parseFloat(value || 0);
    }

    // Update the display path
    this.set(path, formattedHours);
    // Update the data path
    this.set(path.replace('_', ''), dataHours);
    // Update total hours
    this.totalHours = this.timeClasses.reduce((acc, x) => (acc += x.hours), 0);
    // Blur the input
    e.currentTarget.blur();
  }

  updateLiveProps() {
    const currentISODate = DateTime.now().toISODate();
    // If the date has changed, update it
    if (this.liveIsoDate !== currentISODate) this.liveIsoDate = currentISODate;
  }

  updatePieChart() {
    // If we haven't initialized the pie chart yet, try now
    if (this.pieChart == null) {
      // Try to get the pie chart element (returning false if we cannot)
      const pieChartElement = /** @type {HTMLCanvasElement} */ (this.shadowRoot?.querySelector(`#weekTotalsPieChart`));
      const canvas2dContext = pieChartElement?.getContext('2d');
      if (!canvas2dContext) return;

      // Initialize the pie chart
      this.pieChart = new Chart(canvas2dContext, {
        type: 'pie',
        data: { datasets: [] },
        options: {
          plugins: { legend: { align: 'start', display: true, maxWidth: 250, labels: { usePointStyle: true } } },
          responsive: false
        }
      });
    }

    // Filter out overhead categories if pto tracking is turned off
    const weeklyTotals = this.weeklyTotals.filter((weeklyTotal) => {
      if (this.timesheetOptions?.allow_pto_reporting) return true;
      return this.overheadTimeClasses.findIndex((overheadTimeClass) => overheadTimeClass.name == weeklyTotal.class) == -1;
    });

    // Get the labels and data for the pie chart
    const labels = weeklyTotals.map((a) => a.description || a.class);
    const data = weeklyTotals.map((a) => a.hours);
    const colors = weeklyTotals.map((a) => a.color);

    // Do not update the chart if the data is the same
    if (this.pieChart.data.labels?.join() == labels.join() && this.pieChart.data.datasets[0]?.data?.join() == data.join()) return;

    // Otherwise, update the data for the pie chart
    this.pieChart.data = { labels, datasets: [{ label: 'Hours', data, backgroundColor: colors, hoverOffset: 4 }] };

    // Update the display
    this.pieChart.update();
  }

  updateWeekPointer(e) {
    // Get data from element dataset
    const offset = parseInt(e.currentTarget.dataset.offset);
    // Update the pointer object
    this.currentMonday = this.currentMonday?.plus({ days: offset });
    // Auto "select" the new "monday"
    this.selectedDate = this.currentMonday;
  }

  async updateIsTimesheetManager() {
    this.unsubscribeTimesheetManagerRoleListener?.();

    if (!this.user?.uid || !this.userGroup) {
      this.userIsTimesheetManager = false;
      return;
    }

    this.unsubscribeTimesheetManagerRoleListener = ListenToUserRole(
      this.user.uid,
      'timesheet_manager',
      this.userGroup,
      (isTimesheetManager) => (this.userIsTimesheetManager = isTimesheetManager)
    );
  }

  async updateCompanyTeams() {
    this.unsubscribeCompanyTeamsListener?.();

    if (!this.userGroup || !this.user?.uid) {
      this.teamsUserIsLeaderOf = [];
      this.userIsAdminLMA = false;
      return;
    }

    this.unsubscribeCompanyTeamsListener = getCompanyTeams(firebase.firestore(), this.userGroup, (teamsEntries) => {
      this.teamsUserIsLeaderOf = teamsEntries.filter(([, team]) => team.leaders?.includes(this.user.uid));
      this.userIsAdminLMA = this.teamsUserIsLeaderOf.length > 0;
    });
  }

  updateUserTimesheetsListener(uid, userGroup, currentMonday, usingOtherUid) {
    // If any arguments of this update function are undefined, short-circuit
    if (Array.from(arguments).some((arg) => arg == undefined)) return;
    // Determine if we should increase listener extents (or if we already have everything we are looking for, do nothing)
    let newMinimumQueryDate = currentMonday.toISODate();
    if (newMinimumQueryDate >= this.minimumQueryDate && !usingOtherUid) return;
    this.minimumQueryDate = newMinimumQueryDate;

    // If the unsubscribe function exists, call it (DON'T call this unless we know we are going to establish a new listener)
    if (typeof this.userTimesheetsListenerUnsubscribe == 'function') this.userTimesheetsListenerUnsubscribe();

    // TODO (12-14-2021): Remove this eventually
    if (this.userIsTimesheetManager && this.selectedUid) uid = this.selectedUid;
    // Otherwise, get the right start key and set up the listener
    this.timeTrackingCollection = this.firestore.collection(`companies/${userGroup}/time_tracking`);
    const userTimeTrackingQuery = this.timeTrackingCollection
      .where('uid', '==', uid)
      .orderBy('week_starting', 'desc')
      .where('week_starting', '>=', this.minimumQueryDate);
    this.userTimesheetsListenerUnsubscribe = userTimeTrackingQuery.onSnapshot((s) => {
      this.userTimesheets = s.docs.map((doc) => /** @type {KatapultTimesheetRecord} */ ({ ...doc.data(), _ref: doc.ref }));
    });
  }

  // Sets value of emotion to correspond the icon clicked
  setGrowthRating(e) {
    const { srcElement } = e;
    // If the click was not on the faces, return
    if (!srcElement.classList.contains('faces')) return;

    // Get the emotion from the clicked element
    const emotionValue = Number.parseInt(srcElement.getAttribute('name') ?? '0');
    this.timesheetMetadata = { ...this.timesheetMetadata, growthRating: emotionValue };
    this.styleGrowthRatingIcons();
  }

  // Styles icons based in selected emotion.
  styleGrowthRatingIcons() {
    const currentEmotionValue = this.timesheetMetadata.growthRating;
    const emotionIcons = this.shadowRoot?.querySelectorAll('.faces') ?? [];

    for (const emotionIcon of emotionIcons) {
      const emotionValue = Number.parseInt(emotionIcon.getAttribute('name') ?? '0');
      emotionIcon.className = emotionValue == currentEmotionValue ? 'faces' : 'faces notActive';
    }
  }

  resetExportDateRange() {
    this.updateDates();
    this.exportStartDate = this.previousMonday.toISODate();
    this.exportEndDate = this.previousMonday.plus({ days: 6 }).toISODate();
  }

  getTimesheetOptions() {
    // disconnect the old listener
    this.disconnectTimesheetOptionsListener?.();

    if (this.userGroup == null) return;
    // turn on the new listener
    const callback = (snapshot) => (this.timesheetOptions = snapshot.val());
    const timesheetOptionsRef = FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/options/config/timesheets`);
    timesheetOptionsRef.on('value', callback);

    // setup a new disconnect function
    this.disconnectTimesheetOptionsListener = () => timesheetOptionsRef.off('value', callback);
  }

  setTimesheetSubmissionTextEntries() {
    // setup default text values
    const defaultSubmissionVerificationText = 'These are my hours and I understand that they will be used to determine my compensation.';
    const defaultTeamHealthNotesText = 'Anything to share or note from this week?';
    const defaultTeamHealthRatingSystemText = 'How was your work experience this week?';

    // setup all data for ui
    this.submissionVerificationText = this.timesheetOptions?.submission_verification_text ?? defaultSubmissionVerificationText;
    this.submissionVerificationTooltip = this.timesheetOptions?.submission_verification_tooltip;
    this.teamHealthNotesText = this.timesheetOptions?.team_health_notes_text ?? defaultTeamHealthNotesText;
    this.teamHealthNotesTooltip = this.timesheetOptions?.team_health_notes_tooltip;
    this.teamHealthRatingSystemText = this.timesheetOptions?.team_health_rating_system_text ?? defaultTeamHealthRatingSystemText;
    this.teamHealthRatingSystemTooltip = this.timesheetOptions?.team_health_rating_system_tooltip;
  }
}

customElements.define('katapult-timesheet', KatapultTimesheet);
